export const LOGIN_USER = '@auth/LOGIN_USER';
export const LOGIN_SUCCESS = '@auth/LOGIN_SUCCESS';

export const LOGOUT_USER = '@auth/LOGOUT_USER';
export const LOGOUT_USER_SUCCESS = '@auth/LOGOUT_USER_SUCCESS';
export const API_ERROR = '@auth/LOGIN_API_ERROR';

export const TWO_FACTOR_REQUIRED = '@auth/TWO_FACTOR_REQUIRED';
export const TWO_FACTOR_CANCEL = '@auth/TWO_FACTOR_CANCEL';

export const TWO_FACTOR_VERIFY = '@auth/TWO_FACTOR_VERIFY';
export const TWO_FACTOR_VERIFY_SUCCESS = '@auth/TWO_FACTOR_VERIFY_SUCCESS';
export const TWO_FACTOR_VERIFY_ERROR = '@auth/TWO_FACTOR_VERIFY_ERROR';

export const TWO_FACTOR_RESEND = '@auth/TWO_FACTOR_RESEND';
export const TWO_FACTOR_RESEND_SUCCESS = '@auth/TWO_FACTOR_RESEND_SUCCESS';
export const TWO_FACTOR_RESEND_ERROR = '@auth/TWO_FACTOR_RESEND_ERROR';

export const ENTRAID_CALLBACK = '@auth/ENTRAID_CALLBACK';
export const ENTRAID_AUTHORIZATION_ERROR = '@auth/ENTRAID_AUTHORIZATION_ERROR';
